const LinkedinIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-linkedin 1'>
      <path
        id='Vector'
        d='M19.3334 3H5.33337C4.22837 3 3.33337 3.895 3.33337 5V19C3.33337 20.105 4.22837 21 5.33337 21H19.3334C20.4384 21 21.3334 20.105 21.3334 19V5C21.3334 3.895 20.4384 3 19.3334 3ZM9.33337 17H6.81037V10H9.33337V17ZM8.02737 8.717C7.25637 8.717 6.74137 8.203 6.74137 7.517C6.74137 6.831 7.25537 6.317 8.11237 6.317C8.88337 6.317 9.39837 6.831 9.39837 7.517C9.39837 8.203 8.88437 8.717 8.02737 8.717ZM18.3334 17H15.8914V13.174C15.8914 12.116 15.2404 11.872 14.9964 11.872C14.7524 11.872 13.9384 12.035 13.9384 13.174C13.9384 13.337 13.9384 17 13.9384 17H11.4154V10H13.9384V10.977C14.2634 10.407 14.9144 10 16.1354 10C17.3564 10 18.3334 10.977 18.3334 13.174V17Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default LinkedinIcon
